import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { fetchFullCalendarEvent } from 'owa-calendar-forms-common/lib/helpers/eventStore';

export async function getSeriesMasterCollabSpace(instanceEvent: CalendarEvent): Promise<string> {
    let seriesMasterCollabSpace = null;

    const { fullEventPromise } = fetchFullCalendarEvent(
        instanceEvent.ItemId,
        null,
        null,
        true /** isfetchFullSeriesMasterCalendarEventFromEventInstance */,
        {
            fetchSource: 'FullComposeEdit',
        }
    );

    const fullEvent = await fullEventPromise;
    if (fullEvent) {
        seriesMasterCollabSpace = fullEvent.CollabSpace;
    }

    return seriesMasterCollabSpace;
}
